import React from 'react';

export interface IconLockProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconLock: React.FC<IconLockProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M5.00143 7V6.86322C5.00143 5.50563 4.93516 3.99239 5.70448 3.02078C6.14321 2.4667 6.85314 2 8 2C9.14686 2 9.85679 2.4667 10.2955 3.02078C11.0648 3.99239 10.9986 5.50563 10.9986 6.86322V7M3 7.82353C3 7.36869 3 7 3 7H13V12.3529C13 13.2626 13 14 13 14H3C3 14 3 13.2626 3 12.3529V7.82353Z" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" />  
    </svg>
  );
};

export default IconLock;
